<template>
  <div class="balancePayBox">
    <div class="balancePayBox_title">收银台</div>
    <div class="balancePayBox_main">
      <div class="balancePayBox_total">
        <span>订单提交成功，请您尽快付款！ 订单号：25093949805</span>
        <span style="font-size: 14px"
          >应付总额：<span style="font-size:20px;color:#FF4019;font-weight:700"
            >￥298.00</span
          >
          元</span
        >
      </div>
      <div class="balancePayBox_time">
        <span
          >请于24小时内完成付款<span style="color:#777"
            >，若逾期未付款，订单将被取消，需要重新下单！</span
          >剩余时间：22小时55分15秒</span
        >
        <div class="balancePayBox_payHelp">
          支付帮助<i class="iconfont" style="margin-left:11px">&#xe624;</i>
        </div>
      </div>
      <div class="balancePayBox_payMode">
        <el-radio v-model="radio" label="1">余额</el-radio>
        <div>推荐</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "1"
    };
  }
};
</script>

<style scoped>
@import "../../assets/css/balancePay";
</style>



// WEBPACK FOOTER //
// src/components/page/balancePay.vue